export default __webpack_public_path__ + "static/enceinte4-47097d1f42573586e29dab0faa6fa256.jpg";